import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import {
  Box,
  CssBaseline,
  Container,
  Card,
  CardContent,
  Typography
} from "@mui/material";
import { motion, AnimatePresence } from "framer-motion";
import Sidebar from "./Sidebar";
import HomePageContent from "./HomePageContent";
import AboutUsContent from "./AboutUsContent";
import ProductsServicesContent from "./ProductsServicesContent";
import SafetyQualityContent from "./SafetyQualityContent";
import ContactContent from "./ContactContent";
import SuccessStoriesContent from "./SuccessStoriesContent";

const pageVariants = {
  initial: { opacity: 0, y: 10 },
  animate: { opacity: 1, y: 0, transition: { duration: 0.5 } },
  exit: { opacity: 0, y: -10, transition: { duration: 0.3 } },
};

function App() {
  return (
    <Router>
      <CssBaseline />
      <Box display="flex" sx={{ bgcolor: "#F9F9F9", minHeight: "100vh" }}>
        <Sidebar />

        {/* Main Content Area */}
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 3,
            bgcolor: "#FFFFFF",
            color: "#333",
            minHeight: "100vh",
          }}
        >
          <Container maxWidth="lg">
            {/* Logo Section - Centered */}
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              py={2}
            >
              <img
                src="/logo.jpg"
                alt="MBPE Logo"
                width={120}
                height={120}
                style={{ transition: "width 0.3s, height 0.3s" }}
              />
            </Box>

            {/* Main Content Card */}
            <Card sx={{ bgcolor: "#FFFFFF", p: 3, borderRadius: 2, boxShadow: 2 }}>
              <CardContent>
                <AnimatePresence mode="wait">
                  <Routes>
                    <Route
                      path="/"
                      element={
                        <motion.div
                          variants={pageVariants}
                          initial="initial"
                          animate="animate"
                          exit="exit"
                        >
                          <HomePageContent />
                        </motion.div>
                      }
                    />
                    <Route
                      path="/about"
                      element={
                        <motion.div
                          variants={pageVariants}
                          initial="initial"
                          animate="animate"
                          exit="exit"
                        >
                          <AboutUsContent />
                        </motion.div>
                      }
                    />
                    <Route
                      path="/products-services"
                      element={
                        <motion.div
                          variants={pageVariants}
                          initial="initial"
                          animate="animate"
                          exit="exit"
                        >
                          <ProductsServicesContent />
                        </motion.div>
                      }
                    />
                    <Route
                      path="/safety-quality"
                      element={
                        <motion.div
                          variants={pageVariants}
                          initial="initial"
                          animate="animate"
                          exit="exit"
                        >
                          <SafetyQualityContent />
                        </motion.div>
                      }
                    />
                    <Route
                      path="/contact"
                      element={
                        <motion.div
                          variants={pageVariants}
                          initial="initial"
                          animate="animate"
                          exit="exit"
                        >
                          <ContactContent />
                        </motion.div>
                      }
                    />
                    <Route
                      path="/success-stories"
                      element={
                        <motion.div
                          variants={pageVariants}
                          initial="initial"
                          animate="animate"
                          exit="exit"
                        >
                          <SuccessStoriesContent />
                        </motion.div>
                      }
                    />
                  </Routes>
                </AnimatePresence>
              </CardContent>
            </Card>
          </Container>
        </Box>
      </Box>
    </Router>
  );
}

export default App;
